import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {User} from "../../models";
import {Card} from "../../models/card";
import {CardVoucher} from "../../models/cardVoucher";

@Component({
    selector: 'unsuspend-card-dialog',
    templateUrl: './unsuspendCardDialog.component.html',
    styleUrls: ['./unsuspendCardDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class UnsuspendCardDialogComponent {
    action: string;
    customer: User;
    form: FormGroup;
    dialogTitle: string;
    card: Card;
    voucher: CardVoucher;

    constructor(
        public matDialogRef: MatDialogRef<UnsuspendCardDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;
        this.card = _data.card;
        this.voucher = _data.voucher;
    }

}
